import React from 'react';
import { IntroTextBlock, ImageCard } from '../index';
import { Carousel } from '_ui-core-js/React/components/Carousel.jsx';
import { VideoPlayer } from '_ui-core-js/React/components/VideoPlayer.jsx';
import propTypes from 'prop-types';

export function CarouselGallery(props) {

const { heading, copy, settings, items, links, id } = props;
  
    const block = 'c-carousel-gallery';
    return (
        <>
            <article 
                className={`${block}`}
                id={id}
                >
                <IntroTextBlock
                    block={block}
                    heading={heading}
                    copy={copy}
                    links={links}
                />

                <Carousel 
                  centered={true} 
                  infinite={true} 
                  pagination={true}
                  uniformHeight={true}
                >
                  { items.map((media, index) => (
                    ( media.type == "image" ?
                        <ImageCard
                            media={media}
                            link={
                              {
                                "href": media.description,
                                "type": media.description ? "tertiary" : ""
                              }
                            }
                            block={block}
                            cssAnimation={false}
                        />
                        :
                        <VideoPlayer
                            src={media.url}
                            assetRootPath={`${settings.assetRootPath}/assets/images/`}
                            poster={media.poster}
                            fullscreen={!media.disableFullscreenDefault}
                            label={media.label}
                        />
                    ))
                  )}
                </Carousel>
            </article>
        </>
    )
}

CarouselGallery.propTypes = {
  heading:propTypes.string, 
  copy:propTypes.string, 
  links:propTypes.array,
  items:propTypes.array
};

CarouselGallery.defaultProps = {
  items: []
};